module.exports = __webpack_public_path__ + "img/230203온리프_랜딩_공팔리터(배너).d00e12ad.jpg";